module.exports = __webpack_public_path__ + "static/media/prime-card.4bc91caa.svg";